import { useMinutPut, useMinutQuery } from "src/hooks/minutQuery"

import {
  taskTemplateKeys,
  useTaskAutomationCache,
} from "./taskAutomationQueriesCache"

export function useFetchTaskAutomations({ orgId }: { orgId: string }) {
  return useMinutQuery<"/organizations/{organization_id}/tasks/automation">({
    queryKey: taskTemplateKeys.taskAutomations(),
    queryPath: `/organizations/${orgId}/tasks/automation`,
  })
}

export function usePutTaskAutomation() {
  const cache = useTaskAutomationCache()

  return useMinutPut<"/organizations/{organization_id}/tasks/automation">({
    pathFn: (args) => `/organizations/${args.organization_id}/tasks/automation`,
    options: {
      onSettled: () => {
        cache.invalidateTaskAutomations()
      },
    },
  })
}
